import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Pagination } from '@core/models/pagination.model';
import { BreadCrumbService } from '@core/services/bread-crumb.service';
import { Store } from '@ngxs/store';
import { FiltersComponent } from '@shared/ui/filters/filters.component';
import { TableNavigatorComponent } from '@shared/ui/table-navigator/table-navigator.component';
import { TableSkeletonLoaderComponent } from '@shared/ui/table-skeleton-loader/table-skeleton-loader.component';
import { IFILTER } from 'app/app.constants';
import { TableActions } from 'app/auth/table-store/table.actions';
import { TableSelectors } from 'app/auth/table-store/table.selectors';
import { BehaviorSubject, Observable, Subscription, take } from 'rxjs';
import { PermissionDirective } from '@shared/directives/permission.directive';
import { TitleCasePipe, UpperCasePipe } from '@angular/common';
@Component({
  selector: 'app-audit-log',
  standalone: true,
  imports: [
    FiltersComponent,
    TableSkeletonLoaderComponent,
    TableNavigatorComponent,
    CommonModule,
    PermissionDirective,
  ],
  templateUrl: './audit-log.component.html',
  styleUrl: './audit-log.component.scss',
  providers: [TitleCasePipe, UpperCasePipe]
})
export class AuditLogComponent {
  AuditLogListSubject = new BehaviorSubject<any>(null);
  isFetchingAuditLogList$!: Observable<boolean>;
  AuditLogList$ = this.AuditLogListSubject.asObservable();
  totalCountSubject = new BehaviorSubject<number>(0);
  totalCount$: Observable<number> = this.totalCountSubject.asObservable();

  store = inject(Store);
  breadCrumbService = inject(BreadCrumbService);
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);

  subs: Subscription[] = [];
  filterStructure: IFILTER[] = [
    {
      filterKey: 'start_date',
      label: 'Start Date',
      type: 'date',
    },
    {
      filterKey: 'end_date',
      label: 'End Date',
      type: 'date',
    },
    {
      filterKey: 'user',
      label: 'User Type',
      type: 'dropdown',
      dropdown: [
        { key: 'admin', value: 'Admin' },
        { key: 'client', value: 'Client' },
      ],
    },
  ];
  isFilterActive = false;
  hadFilterBefore = false;

  constructor(private titleCasePipe: TitleCasePipe, private upperCasePipe: UpperCasePipe) {
    this.AuditLogList$ = this.store.select(
      TableSelectors.getTableData('auditLog')
    );
    this.totalCount$ = this.store.select(
      TableSelectors.getTableTotalCount('auditLog')
    );
    this.isFetchingAuditLogList$ = this.store.select(
      TableSelectors.getTableLoading('auditLog')
    );
  }
  ngOnInit() {
    this.breadCrumbService.setPageBreadCrumb(this.activatedRoute);
    this.filterEventListener();
    this.loadAuditLogList();
    console.log("Identity Log Component Initialized");
    this.AuditLogList$.subscribe((auditLogList) => {
     console.log("Audit Log List: ", auditLogList);
    })
  }

  filterEventListener() {
    this.activatedRoute.queryParams.subscribe((params) => {
      let query = '';
      if (params[this.filterStructure[0].filterKey]) {
        query = `start_date=${params['start_date']}&`;
      }
      if (params[this.filterStructure[1].filterKey]) {
        query += `end_date=${params['end_date']}&`;
      }
      if (params[this.filterStructure[2].filterKey]) {
        query += `user=${params['user']}&`;
      }
      if (params['search']) {
        query += `search_text=${params['search']}&`;
      }


      // Handle pagination
      const rawPage = params['page'] ? parseInt(params['page']) : 1;
      const page = rawPage > 1 ? rawPage - 1 : 0;
      const take = 10;
      const skip = page * take;

      if (query) {
        query += `skip=${skip}&take=${take}`;
        this.isFilterActive = true;
        this.hadFilterBefore = true;
        this.store.dispatch(
          new TableActions.FilterAuditLogList({ filter: query })
        );
      } else {
        // only re-fetch if there was a previous filter
        if (this.hadFilterBefore || params['page']) {
          this.hadFilterBefore = false;
          this.store.dispatch(
            new TableActions.LoadTableData({
              tableKey: 'auditLog',
              params: new Pagination({ skip: skip, size: take }),
            })
          );
        }
      }
    });
  }
  navigate(currentPage: number) {
    if (this.isFilterActive) {
      this.router.navigate([], {
        queryParams: { page: currentPage },

        queryParamsHandling: 'merge',
      });
    }
  }

  loadAuditLogList(page = 1) {
    const sub = this.AuditLogList$.pipe(take(1)).subscribe((referral) => {
      const hasData = Array.isArray(referral) && referral.length > 0;
      // only dispatch if store is empty
      if (!hasData) {
        this.store.dispatch(
          new TableActions.LoadTableData({
            tableKey: 'auditLog',
            params: new Pagination({
              skip: (page - 1) * 10,
              size: 10,
            }),
          })
        );
      }
    });
    this.subs.push(sub);
  }
}
